/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantPaymentGateway from './tenant-payment-gateway';
import TenantPaymentGatewayDetail from './tenant-payment-gateway-detail';
import TenantPaymentGatewayUpdate from './tenant-payment-gateway-update';
import TenantPaymentGatewayDeleteDialog from './tenant-payment-gateway-delete-dialog';

const TenantPaymentGatewayRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantPaymentGateway />} />
    <Route path="new" element={<TenantPaymentGatewayUpdate />} />
    <Route path=":id">
      <Route index element={<TenantPaymentGatewayDetail />} />
      <Route path="edit" element={<TenantPaymentGatewayUpdate />} />
      <Route path="delete" element={<TenantPaymentGatewayDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantPaymentGatewayRoutes;
